import { render, staticRenderFns } from "./ListProductSelectShop.vue?vue&type=template&id=13ffc9c0"
import script from "./ListProductSelectShop.vue?vue&type=script&lang=js"
export * from "./ListProductSelectShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports